module.exports = "## What is Batch Image Resize Tool?\r\n\r\nImageresize.org provides a bulk/batch resizing tool to easily Resize, compress, or convert multiple images at once. It is an online tool, so there is no software to download or install. You can upload up to 20 images at once using the upload box above."


//////////////////
// WEBPACK FOOTER
// ./src/containers/BulkResize/what-is-batch-resize.md
// module id = 1137
// module chunks = 0